import {
  keepPreviousData,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import { api } from "../../../services/api/axios";

// fetch business/merchant deposits held for manual review
const fetchBusinessDeposit = async ({ page, limit, search }) => {
  const response = await api.get("/v1/admin/business/manual-review-deposits", {
    params: { page, limit, ...(search && { search }) },
  });
  return response.data;
};

export const useBusinessDeposit = (page = 1, limit = 10, search = "") => {
  return useQuery({
    queryKey: ["business-deposit", page, limit, search],
    queryFn: () => fetchBusinessDeposit({ page, limit, search }),
    // Keep the previous page on screen while the next one loads.
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
  });
};

// approve business deposit - no reserve/OTC fields, unlike the personal
// endpoint (a business manual-review hold is always a full-amount credit)
const approveBusinessDeposit = async (uuid) => {
  const { data } = await api.post(
    `/v1/admin/business/approve-deposit/${uuid}`
  );
  return data;
};

export const useApproveBusinessDeposit = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: approveBusinessDeposit,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["business-deposit"] });
    },
  });
};

// decline business deposit
const declineBusinessDeposit = async (payload) => {
  const { data } = await api.post(
    "/v1/admin/business/decline-deposit",
    payload
  );
  return data;
};

export const useDeclineBusinessDeposit = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: declineBusinessDeposit,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["business-deposit"] });
    },
  });
};
